var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.21 3.21a.714.714 0 0 1 1.01 0L8 6.99l3.78-3.78a.714.714 0 0 1 1.01 1.01L9.01 8l3.78 3.78a.714.714 0 0 1-1.01 1.01L8 9.01l-3.78 3.78a.714.714 0 0 1-1.01-1.01L6.99 8 3.21 4.22a.714.714 0 0 1 0-1.01",
    clipRule: "evenodd"
  })));
};
export default SvgClose;